var $7c18ba27b86d3308$exports = {};
$7c18ba27b86d3308$exports = {
  "ascending": "\u05E2\u05D5\u05DC\u05D4",
  "ascendingSort": function ascendingSort(args) {
    return "\u05DE\u05D5\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E2\u05DE\u05D5\u05D3\u05D4 ".concat(args.columnName, " \u05D1\u05E1\u05D3\u05E8 \u05E2\u05D5\u05DC\u05D4");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " \u05E4\u05D9\u05E7\u05E1\u05DC\u05D9\u05DD");
  },
  "descending": "\u05D9\u05D5\u05E8\u05D3",
  "descendingSort": function descendingSort(args) {
    return "\u05DE\u05D5\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E2\u05DE\u05D5\u05D3\u05D4 ".concat(args.columnName, " \u05D1\u05E1\u05D3\u05E8 \u05D9\u05D5\u05E8\u05D3");
  },
  "resizerDescription": "\u05D4\u05E7\u05E9 Enter \u05DB\u05D3\u05D9 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05D4\u05D2\u05D5\u05D3\u05DC",
  "select": "\u05D1\u05D7\u05E8",
  "selectAll": "\u05D1\u05D7\u05E8 \u05D4\u05DB\u05D5\u05DC",
  "sortable": "\u05E2\u05DE\u05D5\u05D3\u05D4 \u05E9\u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D9\u05D9\u05DF"
};
export { $7c18ba27b86d3308$exports as default };